// extracted by mini-css-extract-plugin
export default {"container":"AdminPageTabsSkeleton_container__Xy2Og","tab":"AdminPageTabsSkeleton_tab__yZBV0","text":"AdminPageTabsSkeleton_text__elJHJ"};